/** @format */

export default class Product {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Product();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		// send the product ID to BE unless the search bar has been used
		$(document).on("change", ".js-recommend-product-reference-input", function () {
			$(".js-recommend-product-hidden-id").val("");
		});
	}
}
